module.exports = __webpack_public_path__ + "static/aws-partner-c9e2688ebe5d1ea02d9f2a0993fa07f8.png";